import React from "react";
import "./LoadingScreen.css";

export default function LoadingScreen({ label = "LOADING" }) {
  return (
    <div className="loading-screen">
      <div className="loading-text" aria-label={label}>
        {label}
      </div>
    </div>
  );
}
